<template :lang="this.$i18n.locale">
  <div id="app">
    <el-row v-if="logged && !['preview', 'account-username', '404'].includes(this.$route.name)">
      <el-container>
        <el-header style="position: inherit;">
          <header-top></header-top>
        </el-header>
        <el-container class="visit-app-content-wrapper" v-loading="loading">
          <div class="visit-app-content-wrapper-inner">
            <transition name="el-fade-in-linear">
              <router-view/>
            </transition>
          </div>
        </el-container>
      </el-container>
    </el-row>
    <el-row v-else>
      <el-col :span="24">
        <router-view/>
      </el-col>
    </el-row>
    <new-version v-if="notification && disablePreview" :notification="notification"/>
    <el-dialog
      :visible.sync="showUserMobileMessage"
      size="tiny"
      custom-class="mobile-warning-dialog">
      <div slot="title">
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" style="display: inline-block; vertical-align: middle">
        <path d="M2.91647 17.3334C2.49981 17.3334 2.08314 17.25 1.66647 17C0.499806 16.3334 0.0831394 14.75 0.749806 13.5834L7.83314 1.75004C8.08314 1.41671 8.33314 1.08337 8.66647 0.916707C9.24981 0.583374 9.91647 0.500041 10.5831 0.666707C11.2498 0.833374 11.7498 1.25004 12.1665 1.83337L19.1665 13.5834C19.4165 14 19.4998 14.4167 19.4998 14.8334C19.4998 15.5 19.2498 16.1667 18.7498 16.5834C18.3331 17.0834 17.7498 17.3334 17.0831 17.3334H2.91647ZM9.24981 2.66671L2.24981 14.4167C1.99981 14.8334 2.16647 15.3334 2.58314 15.5834C2.66647 15.6667 2.83314 15.6667 2.91647 15.6667H16.9998C17.2498 15.6667 17.4165 15.5834 17.5831 15.4167C17.7498 15.25 17.8331 15.0834 17.8331 14.8334C17.8331 14.6667 17.8331 14.5834 17.7498 14.4167L10.7498 2.66671C10.4998 2.25004 9.99981 2.16671 9.58314 2.33337C9.41647 2.41671 9.33314 2.50004 9.24981 2.66671Z" fill="#EAB844"/>
        <path d="M9.99981 10.6667C9.49981 10.6667 9.16647 10.3334 9.16647 9.83337V6.50004C9.16647 6.00004 9.49981 5.66671 9.99981 5.66671C10.4998 5.66671 10.8331 6.00004 10.8331 6.50004V9.83337C10.8331 10.3334 10.4998 10.6667 9.99981 10.6667Z" fill="#EAB844"/>
        <path d="M9.99981 14C9.74981 14 9.58314 13.9167 9.41647 13.75C9.24981 13.5834 9.16647 13.4167 9.16647 13.1667C9.16647 13.0834 9.16647 12.9167 9.24981 12.8334C9.33314 12.75 9.33314 12.6667 9.41647 12.5834C9.49981 12.5 9.58314 12.4167 9.66647 12.4167C9.83314 12.3334 9.99981 12.3334 10.1665 12.3334C10.2498 12.3334 10.2498 12.3334 10.3331 12.4167C10.4165 12.4167 10.4165 12.4167 10.4998 12.5C10.4998 12.5 10.5831 12.5834 10.6665 12.5834C10.7498 12.6667 10.8331 12.75 10.8331 12.8334C10.8331 12.9167 10.9165 13.0834 10.9165 13.1667C10.9165 13.4167 10.8331 13.5834 10.6665 13.75C10.4165 13.9167 10.2498 14 9.99981 14Z" fill="#EAB844"/>
        </svg>
        <span class="ml-1 text-body" style="vertical-align: middle">Warning</span>
      </div>
      <div class="text-body" style="border-top: 1px solid #ddd">
        <p>Our webapp is made for computers and/or tablets devices.</p>
        <p>Please, switch to a larger screen device in order to get the best user experience.</p>
        <el-button type="primary" @click="showUserMobileMessage = false" style="width: 100%">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ls from 'local-storage'
import HeaderTop from '@/components/layouts/v1/HeaderTop'
import NewVersion from '@/components/dialogs/NewVersion'
import { getProfile } from '@/api/account'
import MobileDetect from 'mobile-detect'
import initHelpHero from 'helphero'

export default {
  name: 'App',
  components: {
    HeaderTop, NewVersion
  },
  data () {
    return {
      imagePath: process.env.IMAGE_PATH,
      title: '360tovisit',
      showMenu: true,
      paddingLeft: 200,
      hideScrollIcon: true,
      showUserMobileMessage: false,
      isIphone: false,
      disablePreview: false,
      socket: null
    }
  },
  computed: {
    ...mapGetters('account', [
      'logged',
      'accountInfo',
      'pricings',
      'activeProjectNumber',
      'inactiveProjectNumber',
      'firstProject',
      'lastProject'
    ]),
    ...mapGetters(['loading']),
    ...mapGetters('message', ['messages', 'notification']),
    ...mapGetters('project', ['projects', 'project'])
  },
  mounted () {
    this.checkLoged()
    this.title = 'Login'
    if (!Object.keys(this.messages).length) {
      this.fetchMessages({locale: this.$i18n.locale})
    }

    if (!Object.keys(this.notification).length) {
      this.getMessageNotification()
    }

    if (this.$route.name !== 'preview') {
      this.mobileDetectMessage()
      this.disablePreview = true
    }

    if (this.$route.name === 'account-login') {
      this.disablePreview = false
    }
    this.initialSettingLanguage()
    this.fixScreenMobile()
    if (!this.socket) {
      this.initWebsocket()
    }
    this.$eventBus.$on('sendSocketMessage', this.sendSocketMessage)
  },
  methods: {
    ...mapActions('account', ['setAccountInfo', 'checkTotalProjects']),
    ...mapActions('message', ['fetchMessages', 'getMessageNotification']),
    ...mapActions('project', ['fetchProjects']),
    initialSettingLanguage () {
      let lang = ls.get('lang') || 'en'
      this.$i18n.locale = lang
    },
    checkUsername () {
      if (this.$route.name !== 'preview') {
        if (Object.keys(this.accountInfo).length && !this.accountInfo.username) {
          this.$router.push({name: 'account-username'})
        }
      }
    },
    checkLoged () {
      this.hlp = initHelpHero('AkKK4FOuc60')
      let authen = ls.get('authen')
      if (!authen && !['preview', 'account-login', 'account-register', '404'].includes(this.$route.name)) {
        this.$router.push({name: 'account-login'})
        this.hlp.anonymous()
        this.indentifyAnonymousId()
      } else {
        if (authen) {
          getProfile().then(res => {
            if (res.status === 1) {
              this.setAccountInfo(res.data)
              ls.set('user', res.data)
              this.hlp.identify(res.data.id, {
                username: res.data.username,
                email: res.data.email,
                plan: (res.data.pricing && res.data.pricing.title) ? res.data.pricing.title : null
              })
              this.fetchUserDataAndIdentify()
            } else {
              this.messageError()
            }
          })
        } else {
          this.hlp.anonymous()
          this.indentifyAnonymousId()
        }
      }
    },
    toggleAside () {
      this.showMenu = !this.showMenu
      if (this.showMenu) {
        this.paddingLeft = 200
      } else {
        this.paddingLeft = 0
      }
    },
    fixScreenMobile () {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01
      let vw = window.innerWidth * 0.01
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.documentElement.style.setProperty('--vw', `${vw}px`)
      window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        let vw = window.innerWidth * 0.01
        document.documentElement.style.setProperty('--vw', `${vw}px`)
      })
    },
    mobileDetectMessage () {
      let device = new MobileDetect(window.navigator.userAgent)
      if (device.mobile() || device.tablet()) {
        this.showUserMobileMessage = true
        this.isIphone = device.is('iPhone')
      }
    },
    fetchUserDataAndIdentify () {
      this.checkTotalProjects().then((data) => {
        this.identifySegment()
      }).catch(error => {
        console.log(error)
      })
    },
    identifySegment () {
      let firstVt = null
      let lastVt = null
      if (this.firstProject) {
        firstVt = {
          vtId: this.firstProject.id,
          vtUrl: process.env.PUBLIC_TOUR_URL + (this.accountInfo.username ? this.accountInfo.username : this.accountInfo.slug) + '/' + this.firstProject.slug,
          created_at: this.firstProject.created_at
        }
      }
      let subscription = null
      let plan = null
      let pastSubcription = null
      let pastPricing = null
      let pastPlan = null
      if (this.accountInfo.subscriptions && this.accountInfo.subscriptions.length) {
        subscription = this.accountInfo.subscriptions[0]
        if (this.accountInfo.subscriptions.length >= 2) {
          pastSubcription = this.accountInfo.subscriptions[1]
        }
      }
      if (this.lastProject) {
        lastVt = {
          vtId: this.lastProject.id,
          vtUrl: process.env.PUBLIC_TOUR_URL + (this.accountInfo.username ? this.accountInfo.username : this.accountInfo.slug) + '/' + this.lastProject.slug,
          created_at: this.lastProject.created_at
        }
      }
      if (this.accountInfo && this.accountInfo.id) {
        window.analytics.identify(this.accountInfo.id, {
          name: this.accountInfo.name,
          email: this.accountInfo.email,
          phone: this.accountInfo.phone,
          plan: this.accountInfo.pricing ? this.accountInfo.pricing.title : '',
          role: this.accountInfo.role,
          company: this.accountInfo.company_name,
          avatar: this.accountInfo.avatar ? (this.imagePath + this.accountInfo.avatar) : '',
          activevt: this.activeProjectNumber,
          inactivevt: this.inactiveProjectNumber,
          created_at: this.accountInfo.created_at,
          firstVt,
          lastVt,
          lang: this.$i18n.locale
        })
      }
    },
    indentifyAnonymousId () {
      window.analytics.identify(null, {},
        {
          integrations: {
            'All': true,
            'Customer.io': false,
            'hubspot': false
          }
        }
      )
    },
    initWebsocket () {
      const authen = ls.get('authen')
      const userType = 'user'
      this.socket = new WebSocket(
        `${process.env.WEBSOCKET_URL}?token=${authen.token}&user_type=${userType}`
      )
      this.socket.onopen = () => {
        this.socket.onmessage = (event) => {
          this.handleSocketMessage(JSON.parse(event.data))
        }
        this.socket.onclose = () => {
          this.socket = null
          // reconnect
          setTimeout(() => {
            // this.offline = true
            // this.reconnecting = true
            this.initWebsocket()
          }, 2000)
        }
        this.socket.onerror = () => {
          console.error('init socket error', onerror)
          // reconnect
          setTimeout(() => {
            // this.offline = true
            // this.reconnecting = true
            this.initWebsocket()
          }, 2000)
        }
        // change reconnect status
        // this.offline = false
        // setTimeout(() => {
        //   this.reconnecting = false
        // }, 2000)

        this.sendSocketMessage({
          type: 'active_area_changed',
          data: {
            page: 'webapp_step3'
          }
        })
        if (this.project && this.project.id) {
          this.sendSocketMessage({
            type: 'project_id_changed',
            data: this.project.id
          })
        }
      }
    },
    sendSocketMessage (data) {
      if (this.socket && this.socket.readyState === 1) {
        this.socket.send(JSON.stringify({ action: 'sendmessage', data }))
      }
    },
    handleSocketMessage (event) {
      this.$eventBus.$emit('socketMessage', event)
    }
  },
  watch: {
    '$route' (to, from) {
      this.checkUsername()
    }
  }
}
</script>

<style>
#app {
  color: #2c3e50;
}
.el-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-aside {
  position: fixed;
  background-color: #fff;
  border-right: 1px solid #ddd;
  height: calc(100vh - 50px);
}
.app-menu-left {
  min-height: 100vh;
}
.app-content-right {
  height: 100vh;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
}
.app-content-right .header-top {
  background-color: #fff;
  height: 50px;
  box-shadow: 0 2px 2px rgba(0,0,0,0.05), 0 1px 0 rgba(0,0,0,0.05);
}
.app-content-right .content-bottom {
  padding: 10px 15px;
  overflow-y: scroll;
  height: calc(100vh - 55px);
}
.el-container {
  transition: .2s cubic-bezier(.4,0,.2,1);
}
.slide-leave-active,
.slide-enter-active {
  transition: .2s cubic-bezier(.4,0,.2,1);
}
.slide-enter {
  transform: translate(0);
}
.slide-leave-to {
  transform: translate(-300px);
}
/* scroll top */
.scroll-top{
  z-index: 999 !important;
  position: fixed !important;
  right: 20px !important;
  bottom: 20px !important;
}
.border-scroll{
  padding: 7px 10px;
  background: #fff;
  border-radius: 50%;
  border: 1px solid;
}
.el-menu-item.is-active {
  color: rgb(64, 158, 255) !important;
  border-bottom-color: rgb(64, 158, 255) !important;
}
/*custom css*/
.visit-app-content-wrapper {
  padding: 0 18px;
  background-color: #e3e8ee;
}
.visit-app-content-wrapper .visit-app-content-wrapper-inner {
  width: 100%;
  min-height: calc(100vh - 60px);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #ffffff;
  padding: 0 15px;
  border:none;
  /*box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);*/
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.13);
}
.update-dialog__content .refresh {
  display: flex;
  justify-content: center;
  align-items: center;
}
#update-dialog .el-dialog__body {
  padding: 15px !important;
}
.mobile-warning-dialog {
  width: 90vw !important;
}
.mobile-warning-dialog .el-dialog__body {
  padding-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue